import { render, staticRenderFns } from "./JudgeScreenMask.vue?vue&type=template&id=534a9bb3&scoped=true"
import script from "./JudgeScreenMask.vue?vue&type=script&lang=js"
export * from "./JudgeScreenMask.vue?vue&type=script&lang=js"
import style0 from "./JudgeScreenMask.vue?vue&type=style&index=0&id=534a9bb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534a9bb3",
  null
  
)

export default component.exports